import { render, staticRenderFns, recyclableRender, components } from "./addition_subtraction_details.vue?vue&type=template&id=1aca0a86&scoped=true&"
var renderjs
import script from "./addition_subtraction_details.vue?vue&type=script&lang=js&"
export * from "./addition_subtraction_details.vue?vue&type=script&lang=js&"
import style0 from "./addition_subtraction_details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addition_subtraction_details.vue?vue&type=style&index=1&id=1aca0a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca0a86",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/addition_subtraction_details/addition_subtraction_details.vue"
export default component.exports